import { Params, ParamMap } from '@angular/router';

export const PAGE_SIZE_KEY = 'ps';
export const PAGE_NUMBER_KEY = 'pn';

export const toPagingParams = (args: {
	pageNumber?: number;
	pageSize?: number;
}): Params => ({
	[PAGE_NUMBER_KEY]: args.pageNumber,
	[PAGE_SIZE_KEY]: args.pageSize,
});

export const toPagingListArgs = (
	paramMap: ParamMap
): { pageNumber?: number; pageSize?: number } =>
	paramMap.has(PAGE_NUMBER_KEY) || paramMap.has(PAGE_SIZE_KEY)
		? {
				pageNumber: paramMap.has(PAGE_NUMBER_KEY)
					? +paramMap.get(PAGE_NUMBER_KEY)
					: undefined,
				pageSize: paramMap.has(PAGE_SIZE_KEY)
					? +paramMap.get(PAGE_SIZE_KEY)
					: undefined,
		  }
		: undefined;
